import { api } from "./client";
import type {
  CollectionItemKind,
  MaterialAudience,
} from "./collectionTemplates";

// Remediation Tier 2 #11 — admin client for CollectionTemplateBundle.
// Mirrors PhoenixCapital.Api/Controllers/Collection/CollectionTemplateBundlesController.cs
// and the DTOs in CollectionDtos.cs.

export interface CollectionTemplateBundleSlotDto {
  id: string;
  templateId: string;
  templateName: string;
  templateKind: CollectionItemKind;
  templateVersion: number;
  templateActive: boolean;
  order: number;
  isRequired: boolean;
  dueOffsetDays: number | null;
}

export interface CollectionTemplateBundleDto {
  id: string;
  name: string;
  description: string | null;
  audience: MaterialAudience | null;
  audienceTag: string | null;
  active: boolean;
  isDefault: boolean;
  createdAt: string;
  modifiedAt: string;
  slots: CollectionTemplateBundleSlotDto[];
}

export interface SaveCollectionTemplateBundleSlotPayload {
  templateId: string;
  order: number;
  isRequired: boolean;
  dueOffsetDays: number | null;
}

export interface CreateCollectionTemplateBundlePayload {
  name: string;
  description: string | null;
  audience: MaterialAudience | null;
  audienceTag: string | null;
  slots: SaveCollectionTemplateBundleSlotPayload[];
}

export interface UpdateCollectionTemplateBundlePayload
  extends CreateCollectionTemplateBundlePayload {
  active: boolean;
}

const BASE = "/collection/template-bundles";

export const collectionBundlesApi = {
  list: (
    includeInactive = false,
    audience: MaterialAudience | null = null,
  ) =>
    api.get<CollectionTemplateBundleDto[]>(BASE, {
      includeInactive,
      audience: audience ?? undefined,
    }),
  get: (id: string) => api.get<CollectionTemplateBundleDto>(`${BASE}/${id}`),
  create: (body: CreateCollectionTemplateBundlePayload) =>
    api.post<CollectionTemplateBundleDto>(BASE, body),
  update: (id: string, body: UpdateCollectionTemplateBundlePayload) =>
    api.put<CollectionTemplateBundleDto>(`${BASE}/${id}`, body),
  deactivate: (id: string) =>
    api.post<null>(`${BASE}/${id}/deactivate`),
};
